export const environment = {
  production: false,
  defaultauth: 'localhost',
  backend: 'https://api.nikki-staging.nl/api/',
  backend_web: 'https://api.nikki-staging.nl/',
  env: 'staging',
  name: 'NIKKI',
  locale: "en",
  pusher: {
    key: "b7f1a102f794f3cdadc1",
    beamInstanceId: "c0af3d1b-6d3e-44ed-af44-021e18fba9d6"
  },
  firebaseConfig: {
    apiKey: "",
    authDomain: "",
    databaseURL: "",
    projectId: "",
    storageBucket: "",
    messagingSenderId: "",
    appId: "",
    measurementId: "" 
  },
  sentry: {
    dsn: 'https://615367d213c77f5ad92dd450717f8a03@o4507735602298880.ingest.de.sentry.io/4508595395625040',
    environment: 'staging'
  }
};